import * as React from 'react';
import { getCookie, deleteCookie } from '../../lib/utils';

export default function LaunchplanForm({ blok }) {
  const {button_cookie_text, button_text, klaviyo_id} = blok;
  const [isKlaviyoAccepted, setIsKlaviyoAccepted] = React.useState(false);
  const [mounted, setMounted] = React.useState(false);
  const formRef = React.useRef();

  React.useEffect(() => {
    setMounted(true);
    const checkKlaviyoCookie = () => {
      const klaviyoCookie = getCookie('gatsby-gdpr-klaviyo');
      setIsKlaviyoAccepted(klaviyoCookie === 'true');
    };
    checkKlaviyoCookie();
    const intervalId = setInterval(checkKlaviyoCookie, 1000);
    return () => clearInterval(intervalId);
  }, []);

  function openCookieSettings() {
    Object.keys(window.gatsbyPluginGDPRCookiesOptions).forEach((key) => {
      if (key !== 'environemnts' && key !== 'plugins' && key) {
        localStorage.removeItem(window.gatsbyPluginGDPRCookiesOptions[key].cookieName);
        if (
          getCookie(window.gatsbyPluginGDPRCookiesOptions[key].cookieName) !== ''
        ) {
          localStorage.setItem(
            window.gatsbyPluginGDPRCookiesOptions[key].cookieName,
            getCookie(window.gatsbyPluginGDPRCookiesOptions[key].cookieName),
          );
        }
        deleteCookie(window.gatsbyPluginGDPRCookiesOptions[key].cookieName);
      }
    });
    window.location.reload();
  }

  return (
    <div className="px-4 lg:px-16 py-20">
      {mounted && !isKlaviyoAccepted ? (
        <div className="min-h-[50px] my-10">
          <button
            type="button"
            className="underline cursor-pointer"
            onClick={openCookieSettings}
          >
            {button_cookie_text}
          </button>
          <p className="inline">
            {' '}
            {button_text}
          </p>
        </div>
      ) : (
        <div
          className={`klaviyo-form-${klaviyo_id} cursor-pointer my-10`}
          id="launchplan-form"
          data-klaviyo-accepted={isKlaviyoAccepted}
          ref={formRef}
        />
      )}
    </div>
  )
}
